<template>
  <div style="padding: 0 15px;" class="hum-wrap">
    <svg
      :class="{ 'is-active': isActive }"
      class="hamburger"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      @click="toggleClick"
    >
      <path
        d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
      />
    </svg>

    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
          <span
            v-if="
              item.redirect === 'noRedirect' || index == levelList.length - 1
            "
            class="no-redirect"
          >
            {{ getTitle(item.meta) }}
          </span>
          <a v-else @click.prevent="handleLink(item)">
            {{ getTitle(item.meta) }}
          </a>
          <!-- <span v-else>{{ getTitle(item.meta) }}</span> -->
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp';
import { $onEvent } from '@/utils/emit.js'; // $onEvent.$off('toggleClick');
import Cookies from 'js-cookie';
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      levelList: [],
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();

    $onEvent.$on('toggleClick', bool => {
      if (Cookies.get('sidebarStatus') != 0) {
        this.$emit('toggleClick');
      }
      if (bool) {
        this.$emit('toggleClick');
      }
    });
    this.$once('hook:beforeDestroy', () => {
      $onEvent.$off('toggleClick');
    });
  },
  methods: {
    getTitle(m) {
      return m.titleFn ? m.titleFn(this.$route, m) : m.title;
    },
    getBreadcrumb() {
      // only show routes with meta.title or meta.titleFn
      let matched = this.$route.matched.filter(
        item => item.meta && (item.meta.title || item.meta.titleFn)
      );
      const first = matched[0];
      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: 'Dashboard' } }].concat(
          matched
        );
      }
      const all = matched.filter(
        item =>
          item.meta &&
          (item.meta.title || item.meta.titleFn) &&
          item.meta.breadcrumb !== false
      );
      // 去掉第一级
      this.levelList = all.slice(1, all.length);
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return (
        name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
      );
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      if (
        _.get(item, 'components.default.name', '')
          .toLocaleLowerCase()
          .includes('layout')
      ) {
        // 纯布局不可跳转
        return;
      }
      //
      const { redirect, path } = item;

      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
    toggleClick() {
      this.$emit('toggleClick');
    },
  },
};
</script>

<style scoped lang="scss">
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.hamburger.is-active {
  transform: rotate(180deg);
}

.hum-wrap {
  display: flex;
  align-items: center;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}

::v-deep .el-breadcrumb__item {
  cursor: default;
}
</style>
